import { render, staticRenderFns } from "./FireRiskDashboard.page.vue?vue&type=template&id=47b60132&scoped=true"
import script from "./FireRiskDashboard.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./FireRiskDashboard.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FireRiskDashboard.page.vue?vue&type=style&index=0&id=47b60132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b60132",
  null
  
)

export default component.exports